import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=b4460f1e&scoped=true&"
import script from "./orderList.js?vue&type=script&lang=js&"
export * from "./orderList.js?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=b4460f1e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4460f1e",
  null
  
)

export default component.exports